import { render, staticRenderFns } from "./InstructionsCard.vue?vue&type=template&id=1fa8c024&scoped=true&"
import script from "./InstructionsCard.vue?vue&type=script&scoped=true&lang=js&"
export * from "./InstructionsCard.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./InstructionsCard.vue?vue&type=style&index=0&id=1fa8c024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa8c024",
  null
  
)

export default component.exports